import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { LocalStorageService } from '../../../../core/services/localStorage/local-storage.service';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { AuthStateService } from '../../../../core/services/auth-state/auth-state-service.service';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';
import { resolveNotesRule } from '../../../../core/utils/form.utils';

interface AccountData {
  reference: string;
  lastname: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}

@Component({
  selector: 'app-general-form',
  standalone: true,
  imports: [ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule,
    CommonModule],
  templateUrl: './general-form.component.html',
  styleUrl: './general-form.component.css'
})
export class GeneralFormComponent {
  @Input() orderData?: any;
  @Input() ladata: any = [];
  @Output() emitSubmit = new EventEmitter<string>();
  account_type = this.authStateService.getAccountType();

  generalForm: FormGroup = new FormGroup({});

  draft = false;
  order_reference: string = '';
  stage?: any;
  newStage: string = '';
  isDigitalCircuit = false;

  role: any;

  back = "";
  next_ok = "";
  next_ko = "";
  btn_fast_actions = false;
  agentData: AccountData[] = [];
  salesAgentData: any[] = [];
  vendorData: AccountData[] = [];
  brokerData: AccountData[] = [];
  supplierData: AccountData[] = [];
  supplierTypeData: any[] = [{ name: 'Prescripción broker', key: 'referral_broker' }, { name: 'Prescripción devolución', key: 'referral_vendor' }];
  supplierSellerCodes: any[] = [];
  stagesData: { key: string }[] = [];
  step: number = 1;
  isBrokerSales: boolean = false;
  notesMode: 'public' | 'private' = 'public';

  constructor(private fb: FormBuilder, private authStateService: AuthStateService, private modelService: ModelService, private alertService: AlertService, private localStorageService: LocalStorageService, private orderService: OrdersService) {
    const accountType = this.authStateService.getAccountType();
    const role = this.authStateService.getRole();

    this.isBrokerSales = accountType === 'broker' && role === 'sales';

    this.generalForm = this.fb.group({
      broker_id: [''],
      broker_agent: ['', Validators.required],
      broker_agent_id: [''],
      broker_reference: ['', Validators.required],
      broker_sales_agent_id: [''],
      notes_visibility: ["", Validators.required],
      notes: ["", Validators.required],
      stage: ['draft'],
      supplier_id: [''],
      supplier_agent: ['', Validators.required],
      supplier_agent_id: [''],
      supplier_reference: ['', Validators.required],
      vendor_id: [''],
      vendor_date: ['', Validators.required],
      vendor_quote_reference: ['', Validators.required],
      vendor_agent_id: ['', Validators.required],
      vendor_reference: ['', Validators.required],
      supplier_type: [''],
      supplier_seller_code: [''],

    });
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

  }
  check_selects_length() {
    if (this.agentData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ broker_agent_id: this.agentData[0].reference });
      this.generalForm.patchValue({ supplier_agent_id: this.agentData[0].reference });
    }
    if (this.brokerData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ broker_id: this.brokerData[0].reference });
    }
    if (this.supplierData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ supplier_id: this.supplierData[0].reference });
    }
    if (this.vendorData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ vendor_id: this.vendorData[0].reference });
    }
  }

  checkUpdateForm(): boolean {
    if (this.generalForm.dirty) {
      return true;
    } else {
      return false;
    }
  }

ngOnChanges(changes: SimpleChanges) {
  if (changes) {
    if (changes['ladata']) {
      if (this.ladata) {
        this.role = this.authStateService.getRole();
        this.agentData = this.ladata.agentData;
        this.salesAgentData = (this.ladata.agentData || []).filter((a: any) => a.roles === 'Sales');

        this.vendorData = this.ladata.vendorData.sort((a:any, b:any) =>
          a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
        );

        this.brokerData = this.ladata.brokerData;
        this.supplierSellerCodes = this.ladata.supplierSellerCodes;

        this.supplierData = this.ladata.supplierData.sort((a:any, b:any) =>
          a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
        );

        if (this.account_type == 'broker' && !this.draft) {
          this.generalForm.controls['broker_agent_id'].setValue(
            this.authStateService.getUserReference()
          );
        }
        if (this.orderData) {
          this.refrescarFormulario();
        }
        this.check_selects_length();
      }
    }
    if (changes['orderData']) {
      if (this.orderData) {
        this.refrescarFormulario();
      }
    }
  }
}

  changeStage(event: any) {
    this.newStage = event?.key ?? event;
    this.btn_fast_actions = false;
  }

  searchAgent(term: string, item: AccountData): boolean {
    const fullName = `${item.name} ${item.lastname}`.toLowerCase();
    return fullName.includes(term.toLowerCase());
  }

  refrescarFormulario() {
    this.setVariables();
    if (this.orderData?.stages) {
      this.stagesData = (this.orderData.stages as string[]).map(s => ({ key: s }));
    }
    this.updateFieldAccessibility();
    this.authStateService.setSelectedSupplier(this.orderData?.supplier);
    for (const key in this.orderData) {
      const control = this.generalForm.controls[key];
      const value = this.orderData[key];
      if (control) {
        control.setValue(value);
      }
      if (control) {
        switch (key) {
          case 'broker_agent_id':
            if (this.account_type === 'broker') {
              control.setValue(value);
            } else {
              const brokerAgentName = `${
                this.orderData?.broker_agent?.name || ''
              } ${this.orderData?.broker_agent?.lastname || ''}`.trim();
              this.generalForm.get('broker_agent')?.setValue(brokerAgentName);
              control.setValue(value);
            }
            break;
          case 'supplier_agent_id':
            if (this.account_type === 'supplier') {
              control.setValue(value);
            } else {
              const supplierAgentName = `${
                this.orderData?.supplier_agent?.name || ''
              } ${this.orderData?.supplier_agent?.lastname || ''}`.trim();
              this.generalForm
                .get('supplier_agent')
                ?.setValue(supplierAgentName);
              control.setValue(value);
            }
            break;
          case 'notes_visibility':
            this.generalForm.get('notes_visibility')?.setValue(this.getNotesVisibility());
            break;
          case 'notes':
            this.generalForm.get('notes')?.setValue('');
            break;
          default:
            control.setValue(value);
            break;
        }
      }


    }
    this.btn_fast_actions = this.orderData?.next_ok || this.orderData?.next_ko ? true : false;
    this.alertService.close();
  }

  updateFieldAccessibility() {
    const visibility = this.getNotesVisibility();
    this.notesMode = visibility;
    var rules: Record<string, any> = { ...resolveNotesRule(this.orderData?.rules, visibility), notes_visibility: 'w' };
    // Deshabilitar todos los campos por defecto
    for (const field in this.generalForm.controls) {
      if (this.generalForm.controls.hasOwnProperty(field)) {
        this.generalForm.get(field)?.disable();
      }
    }

    // Habilitar solo los campos con valor 'w' en las reglas
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.generalForm.get(field)?.enable();
      }
    }

  }

  private getNotesVisibility(): 'public' | 'private' {
    const rules = this.orderData?.rules;
    // Si el backend provee notes_public/notes_private, decidir por rules
    if (rules && ('notes_public' in rules || 'notes_private' in rules)) {
      // Ambas en 'w' → público | public 'r' y private 'w' → privado
      if (rules.notes_public === 'w') return 'public';
      if (rules.notes_private === 'w') return 'private';
      return 'public';
    }
    // Fallback: lógica legacy por rol
    const role = this.authStateService.getRole();
    return (this.isBrokerSales || role === 'Logistics' || role === 'Workshop')
      ? 'private' : 'public';
  }

  onSubmitOrderFast(stage: string) {
    this.emitSubmit.emit(stage);
  }

  changeSupplier(event: any) {
    const selectedValue = event;
    const selectedSupplier = this.supplierData.find(supplier => supplier.reference === selectedValue);
    if (selectedSupplier) {
      this.authStateService.setSelectedSupplier(selectedSupplier);
    }
  }

  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  // Etapas desde contract_accepted en adelante (fuera del circuito digital)
  private readonly POST_DIGITAL_STAGES = [
    'contract_accepted', 'registering', 'pre_delivery', 'plates', 'documentation',
    'washing', 'logistics', 'dealership_accessories', 'delivered', 'after_sales',
    'after_sales_factory', 'after_sales_dealership', 'after_sales_billing',
    'after_sales_registering', 'after_sales_prepared', 'after_sales_logistics',
    'after_sales_rejected', 'after_sales_delivered', 'after_sales_without_requirement',
    'not_delivered'
  ];

  setVariables() {
    this.back = this.orderData?.back || '';
    this.next_ok = this.orderData?.next_ok;
    this.next_ko = this.orderData?.next_ko;
    this.stage = this.orderData?.stage;
    this.draft = this.orderData ? true : false;
    this.order_reference = this.orderData?.reference;
    this.isDigitalCircuit = this.orderData?.digital === true
      && !this.POST_DIGITAL_STAGES.includes(this.orderData?.stage);
  }

}
